"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDisabledMinute = exports.isDisabledHour = exports.getToday = exports.Calendar = void 0;
// eslint-disable-next-line import/no-duplicates -- bundle size対策のため、localeのimportは分ける必要がある。
var date_fns_1 = require("date-fns");
// eslint-disable-next-line import/no-duplicates -- bundle size対策のため、localeのimportは分ける必要がある。
var ja_1 = __importDefault(require("date-fns/locale/ja"));
exports.Calendar = {
    sunday: "日",
    monday: "月",
    tuesday: "火",
    wednesday: "水",
    thursday: "木",
    friday: "金",
    saturday: "土",
    ok: "設定",
    today: "今日",
    yesterday: "昨日",
    hours: "時",
    minutes: "分",
    seconds: "秒",
    formattedMonthPattern: "yyyy/MM",
    formattedDayPattern: "yyyy MM dd",
    dateLocale: ja_1.default,
};
var getToday = function () {
    var currentDate = new Date();
    return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
};
exports.getToday = getToday;
var isDisabledHour = function (hour, date) {
    var currentDate = new Date();
    var currentHours = currentDate.getHours();
    if ((0, date_fns_1.isAfter)(date, (0, date_fns_1.addDays)((0, exports.getToday)(), 1))) {
        return false;
    }
    if ((0, date_fns_1.isBefore)(date, (0, exports.getToday)())) {
        return true;
    }
    return hour < currentHours;
};
exports.isDisabledHour = isDisabledHour;
var isDisabledMinute = function (targetMinute, date, selectedHours) {
    var currentDate = new Date();
    var currentMinutes = currentDate.getMinutes();
    var currentHours = currentDate.getHours();
    if (selectedHours === null) {
        //0時や0分が選ばれた時を考慮して === null で条件を判定
        selectedHours = currentHours;
    }
    if ((0, date_fns_1.isAfter)(date, (0, date_fns_1.addDays)((0, exports.getToday)(), 1))) {
        return false;
    }
    if ((0, date_fns_1.isBefore)(date, (0, exports.getToday)())) {
        return true;
    }
    if (selectedHours > currentHours) {
        return false;
    }
    if (selectedHours < currentHours) {
        return true;
    }
    return targetMinute < currentMinutes;
};
exports.isDisabledMinute = isDisabledMinute;
